import { getMerchantStructureByMerchantId, postCreateChannel } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { CreateChannelForm } from '@/components/shared/components/CreateChannelDialog/components/CreateChannelForm';
import {
  CreateChannelSchema,
  CreateChannelType,
} from '@/components/shared/components/CreateChannelDialog/schema/CreateChannelSchema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const CreateChannelDialog = ({
  merchantId,
  opened,
  setOpened,
  toggleDialog,
}: {
  merchantId: string;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
}) => {
  const { revalidate } = useCache(getMerchantStructureByMerchantId, { merchantId }, { revalidateOnMount: false });
  const { request, loading } = useRequest();

  const onSubmitForm = async (useFormValues: CreateChannelType) => {
    await request(postCreateChannel, {
      merchantId,
      description: useFormValues.description,
      type: useFormValues.type,
      id: uuidv4(),
    });
    toggleDialog();
    revalidate();
  };
  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'ADD_CHANNEL'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={CreateChannelSchema}
    >
      <CreateChannelForm fullWidth fieldVariant={FieldVariant.form} />
    </EditDialogWrapper>
  );
};
